//React
//Components
import {
  Button,
  Card,
  FlexBox,
  Image,
  Input,
  Screen,
  TitleBlock,
  TranslatedString,
} from "components";
import React, { useEffect, useState } from "react";
import ROUTE_PATH from "Routes/paths";
import { setGeneralDetails, useGeneralDetails } from "Slices";
//Utils
import { ChangeHistory, getURLParameter } from "utils";
//Styles
import "./styles.scss";
//Libraries
import cx from "classnames";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
//Assets
import WordPressLogo from "assets/platforms/wordpress-icon.png";
import ShopifyLogo from "assets/platforms/shopify.png";
import JavascriptLogo from "assets/platforms/javascript.png";
import ReactLogo from "assets/platforms/react.png";
import AngularLogo from "assets/platforms/angular.png";
import AndroidNativeLogo from "assets/platforms/android-native.png";
import IosNativeLogo from "assets/platforms/ios-native.png";
import ReactNativeLogo from "assets/platforms/react-native.webp";
import secureLocalStorage from "react-secure-storage";

const Platform = () => {
  const [orgName, setOrgName] = useState("");

  useEffect(() => {
    if (getURLParameter("mid") || secureLocalStorage.getItem("mid")) {
      getURLParameter("mid") &&
        secureLocalStorage.setItem("mid", getURLParameter("mid"));
      getURLParameter("mtId") &&
        secureLocalStorage.setItem("mtId", getURLParameter("mtId"));
      window.history.pushState(
        {},
        document.title,
        window.location.href.split("?")[0]
      );
      window
        .fetch("https://metaverse.otpless.app/v1/merchant/getMerchantDetails", {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          method: "POST",
          body: JSON.stringify({
            mid: secureLocalStorage.getItem("mid"),
            utm: window.location.href,
            utm_source: getURLParameter("utm_source"),
            utm_medium: getURLParameter("utm_medium"),
            utm_campaign: getURLParameter("utm_campaign"),
          }),
        })
        .then((res) => res.json())
        .then((data) => {
          if (data.success) {
            setOrgName(data?.data?.orgName);
          } else {
            secureLocalStorage.removeItem("mid");
            ChangeHistory("back", ROUTE_PATH.SAMPLES.LANDING);
          }
        });
    } else {
      ChangeHistory("back", ROUTE_PATH.SAMPLES.LANDING);
    }
  }, []);

  //Return UI
  return (
    <Screen
      className="platform-screen"
      hasHeader
      screenAnimationClass="no-animation"
    >
      <FlexBox
        flexColumn
        justifyBetween={window.screen.width > 768}
        className="middle-section pd-20"
      >
        <p className="fs-20 font-heavy">Choose your Platform</p>
        <div>
          <p
            className={cx(
              window.screen.width < 768 && "mr-t-30",
              "fs-16 font-medium mr-b-10"
            )}
          >
            Plugins
          </p>
          <FlexBox className="gp-20">
            <FlexBox
              justifyCenter
              alignCenter
              flexColumn
              className="w-30 clicking-animation card animated zoomIn delay-01s"
              onClick={() => {
                ChangeHistory("push", ROUTE_PATH.PLUGINS.WORDPRESS);
              }}
            >
              <Image src={WordPressLogo} className="w-70" />
              <p className="mr-t-5 fs-14 font-medium">WordPress</p>
            </FlexBox>
            {/* <FlexBox
              justifyCenter
              alignCenter
              className="w-30 clicking-animation card animated zoomIn delay-02s"
            >
              <Image src={ShopifyLogo} className="w-100" />
            </FlexBox> */}
          </FlexBox>
        </div>
        <div>
          <p
            className={cx(
              window.screen.width < 768 && "mr-t-30",
              "fs-16 font-medium mr-b-10"
            )}
          >
            Website
          </p>
          <FlexBox justifyBetween>
            <FlexBox
              justifyCenter
              alignCenter
              flexColumn
              className="w-30 clicking-animation card animated zoomIn delay-03s"
              onClick={() => {
                ChangeHistory("push", ROUTE_PATH.PLATFORM.JAVASCRIPT);
              }}
            >
              <Image src={JavascriptLogo} className="w-70" />
              <p className="mr-t-5 fs-14 font-medium">Javascript</p>
            </FlexBox>
            <FlexBox
              justifyCenter
              alignCenter
              flexColumn
              className="w-30 clicking-animation card animated zoomIn delay-04s"
              onClick={() => {
                ChangeHistory("push", ROUTE_PATH.PLATFORM.REACT_JS);
              }}
            >
              <Image src={ReactLogo} className="w-70" />
              <p className="mr-t-5 fs-14 font-medium">React JS</p>
            </FlexBox>
            <FlexBox
              justifyCenter
              alignCenter
              flexColumn
              className="w-30 clicking-animation card animated zoomIn delay-05s"
              onClick={() => {
                ChangeHistory("push", ROUTE_PATH.PLATFORM.ANGULAR);
              }}
            >
              <Image src={AngularLogo} className="w-70" />
              <p className="mr-t-5 fs-14 font-medium">Angular</p>
            </FlexBox>
          </FlexBox>
        </div>
        <div>
          <p
            className={cx(
              window.screen.width < 768 && "mr-t-30",
              "fs-16 font-medium mr-b-10"
            )}
          >
            App
          </p>
          <FlexBox>
            <FlexBox
              justifyCenter
              alignCenter
              flexColumn
              className="w-30 clicking-animation card animated zoomIn delay-06s"
              onClick={() => {
                ChangeHistory("push", ROUTE_PATH.PLATFORM.ANDROID);
              }}
            >
              <Image src={AndroidNativeLogo} className="w-70" />
              <p className="mr-t-5 fs-14 font-medium">Android</p>
            </FlexBox>
            <FlexBox
              justifyCenter
              alignCenter
              flexColumn
              className="w-30 clicking-animation card animated zoomIn delay-07s mr-l-20"
              onClick={() => {
                ChangeHistory("push", ROUTE_PATH.GENERAL.HELP);
              }}
            >
              <Image src={IosNativeLogo} className="w-70" />
              <p className="mr-t-5 fs-14 font-medium">iOS</p>
            </FlexBox>
            {/* <FlexBox
              justifyCenter
              alignCenter
              className="w-30 clicking-animation card animated zoomIn delay-08s"
            >
              <Image src={ReactNativeLogo} className="w-100" />
            </FlexBox> */}
          </FlexBox>
        </div>
      </FlexBox>
    </Screen>
  );
};

export default Platform;
